import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't reset scroll on route changes by default.
// Reset to top whenever the path changes (but not when only the query string
// changes, so facet toggles on the same lens page don't yank scroll).
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
